import React, { useState } from "react";
import { IconProp } from ".";
export default function DeleteIcon(props: IconProp) {
    const { width = 24, height = 24, color = "black", onClick = () => {}, hoverColor } = props;

    const [isHover, setIsHover] = useState<boolean>(false);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={width}
            viewBox="0 0 24 24"
            fill="none"
            onClick={onClick}
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            <circle cx="12" cy="12" r="10" fill={isHover ? hoverColor : color} />
            <path d="M8 12L16 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
